import React, { useState, useEffect, useRef } from 'react';
import '../../../dashboard/subContent/searchContainer/SearchContainer.css';
import { AnimatePresence, motion } from 'framer-motion';
import { useForm } from 'react-hook-form';
import logger from '../../../../utils/logger';
import { CustomInputSearch } from '../../../dashboard/subContent/searchContainer/CustomInputSearch';
import { OverlayTrigger } from "react-bootstrap";
import { Tooltip } from "react-bootstrap";
import { MemberService } from '../../../../services/MemberService';
import { useSelector } from 'react-redux';
import { FormationService } from '../../../../services/formationService';
import { getDateType } from './helper/setDate';

export const AdvanceSearcherComponent = ({ handleData, searchSchema, url, handleFiltered, handleLoading, }) => {


  //? Se resetea los datos para ArrayRender
  useEffect(() => {

    handleData([])
    handleFiltered(null)
  }, [])


  //?Controlador de datos obtenidos para renderizar

  const handleSearch = async (dataToSearch) => {

    logger.debug('advanceSearch. data to send: ', dataToSearch)


    // //? Filtrado para enviar solo parametros de los campos que se completaron
    // const cleaned = Object.fromEntries(
    //   Object.entries(dataToSearch).filter(([key, value]) => value !== "" && value !== null)

    // )
    // logger.debug('advanceSearch. cleaned data to send: ', cleaned)

    // const response = await FormationService.getFormations(cleaned, url);
    // logger.debug('getFormations response: ', response)

    // handleFiltered(response?.data?.totalFiltered)
    // handleData(response.data);

    try {
      handleLoading(true);

      const cleaned = Object.fromEntries(
        Object.entries(dataToSearch).filter(([key, value]) => value !== "" && value !== null))

      const response = await FormationService.getFormations(cleaned, url);

      handleFiltered(response?.data?.totalFiltered ?? 0);
      handleData(response?.data ?? []);

    } catch (error) {
      logger.error('error de busqueda avanzada: ', error);
    } finally {
      handleLoading(false);
    }
  };

  //? lista de opciones para el combo

  const selectListOptions = useSelector((data) => data.commonData.lista.formationPlaces)




  const [isVisible, setIsVisible] = useState(true);

  logger.debug('searchSchema: ', searchSchema)
  logger.debug('selectListOptions: ', selectListOptions)




  const { register, handleSubmit, reset, watch } = useForm({

    defaultValues: {
      FormationPlaceId: "0", // 👈 siempre string
      DateFrom: getDateType().From,
      DateTo: getDateType().To
    }
  })
  const onSubmit = (data) => {
    logger.info('data: ', data)

    const newObjet = {
      ...data,

    }

    handleSearch(newObjet)
  }

  const onClean = (data) => {
    const emptyValues = {
      ...Object.fromEntries(Object.keys(data).map(key => [key, ""])),
      FormationPlaceId: "0",
      DateFrom: getDateType().From,
      DateTo: getDateType().To
    };


    reset(emptyValues)
    handleFiltered(null)

    //?Se comenta cleanObject y handleData(cleanObject) para evitar realizar una nueva llamada al a Api

    // const cleanObject = {
    //   ...emptyValues,
    //   PageSize: 10,
    //   PageIndex: 1,
    // }

    // handleData(cleanObject)

    handleData([]);


  }


  const searchRef = useRef(null);


  //? switch para mostrar o cerrar le buscador cuando se haga click en el boton que lo despliega 
  const toggleSearch = () => {
    setIsVisible(prev => !prev);
  }



  //?Efecto para cerrar el buscador cuando se hace click fuera de el
  useEffect(() => {
    const handleClickOutside = (event) => {
      // if (searchRef.current && !searchRef.current.contains(event.target)) {
      //   setIsVisible(false)
      // }
    };

    document.addEventListener('mousedown', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])



  const [cleanEnable, setCleanEnable] = useState(false)
  const allValues = watch()

  useEffect(() => {
    const hasValues = Object.values(allValues).some(val => val !== "" && val !== "0")

    if (hasValues) {
      setCleanEnable(true)
    } else {
      setCleanEnable(false)
    }
  }, [allValues])

  return (
    <div className={`search  active-search-container ${isVisible && 'searchMobileStyle'}`} ref={searchRef}>

      <div className="buttons-searchers-containers d-flex">

        {cleanEnable && isVisible === false &&

          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id={`tooltip-top`}>Limpiar búsqueda</Tooltip>}
          >
            <button
              id="btnCleanAdvancedSearch"
              type='button'
              className="btn btn-link color-gray decoration-none d-flex "
              onClick={handleSubmit(onClean)}
            >
              <span className="icon-trash">
                <i className="bi bi-trash3 outline trashClass"></i>
                <i className="bi bi-trash3-fill fill trashClass"></i>
              </span>

            </button>
          </OverlayTrigger>
        }

      </div>


      {isVisible &&
        <div className="d-flex w-100">
          <form
            className=" aSearch-container formation-search-form"
            onSubmit={handleSubmit(onSubmit)}>


            {searchSchema && searchSchema.map((i) => {


              if (i.hasOwnProperty("select") && i.select === 'true') {
                return (selectListOptions && selectListOptions.length > 0 &&

                  <div className="form-floating form-aSearch" key={i.id}>

                    <select
                      {...register(i.name)}
                      id={i.name}
                      name={i.name}
                      className="form-select pt-0 formation-selects"
                      defaultValue=""
                    >
                      {selectListOptions.map((option, index) => {

                        return <option key={index} value={option.id}> {option.name}</option>
                      })

                      }
                    </select>

                    <label className="label-fButtons" htmlFor={i.name}>{i.labelTitle}</label>
                  </div>
                )
              } else {
                return <CustomInputSearch
                  key={i.name}
                  register={register}
                  name={i.name}
                  type={i.type}
                  placeholder={i.labelTitle}
                />
              }
            })}





            {cleanEnable &&
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip id={`tooltip-top`}>Limpiar búsqueda</Tooltip>}
              >
                <button
                  id="btnCleanAdvancedSearch"
                  type='button'
                  className="btn btn-link color-gray decoration-none d-flex formation-trash-icon"
                  onClick={handleSubmit(onClean)}
                >
                  <span className="icon-trash">
                    <i className="bi bi-trash3 outline trashClass"></i>
                    <i className="bi bi-trash3-fill fill trashClass"></i>
                  </span>
                  {/* <span>Limpiar</span> */}
                </button>
              </OverlayTrigger>
            }


            <button
              type='submit'
              disabled={!cleanEnable}
              className="btn-Asearch2 btn  formation-submit-btn"
              onClick={() => {
                // toggleSearch();
                setTimeout(() => {
                  // window.scrollTo({
                  //   top: document.body.scrollHeight,
                  //   behavior: 'smooth'
                  // })
                }, 500);


              }}
            >
              <span>Buscar</span>
            </button>

          </form>
        </div>
      }



    </div >
  );
};
